import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

var aiConnectionString;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    aiConnectionString = "InstrumentationKey=00000000-0000-0000-0000-000000000000;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/";
} else {
    aiConnectionString = "InstrumentationKey=480b4ddf-bb92-43e6-892c-21d6ec73ea49;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/";
}

export var reactPlugin = new ReactPlugin();
export var appInsights = new ApplicationInsights({
    config: {
        connectionString: aiConnectionString,
        enableAutoRouteTracking: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        extensions: [reactPlugin]
    }
});
appInsights.loadAppInsights();